import React, { Component } from "react"
import Layout from "../components/layout-partnership";
import "../css/sharan-style.css";
import "../css/style.css";
import "../css/animate.min.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import "../css/swiper-bundle.min.css";
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Mousewheel, Parallax } from 'swiper'

Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, Thumbs, Mousewheel, Parallax]);


class UnismarterPartnerUniversitiesSlider extends Component {

  componentDidMount() {
    var swiper = new Swiper('.partner-swiper', {
      slidesPerView: 6,
      spaceBetween: 40,
      autoplay: true,
      // direction: 'vertical',
      speed: 300,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        992: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
        // when window width is >= 640px
        1200: {
          slidesPerView: 6,
          spaceBetween: 30,
        }
      }
    });

    var swiper = new Swiper('.blogs-swiper', {
      slidesPerView: 2,
      spaceBetween: 5,
      autoplay: true,
      // direction: 'vertical',
      speed: 300,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        // when window width is >= 480px
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        // when window width is >= 640px
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        }
      }
    });
  }
  render() {
    return (
      <Layout >
        <section className="partner-sec partner-custom-styling">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h3> Pre Approved University Partners </h3>
              </div>
              <div className="col-md-12 mt-3">
                <div className="partner-inner">
                  <div className="swiper-container partner-swiper">
                    <div className="swiper-wrapper d-flex align-items-center">
                      <div id="unismarter-slider-img" className="swiper-slide logo-position9"><a href="#"><img id="unismarter-slider-img" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/Eynesbury_Logo_Lockup_UoA_CMYK-min_csfbno.png" alt="" /></a></div>
                      <div id="unismarter-slider-img" className="swiper-slide logo-position5"><a href="#"><img id="unismarter-slider-img" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/Deakin_College_Co-brand_logo_MONO-01_zladc9.jpg" alt="" /></a></div>
                      <div id="unismarter-slider-img" className="swiper-slide logo-position1"><a href="#"><img id="unismarter-slider-img" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/Griffith_college_mc798h.png" alt="" /></a></div>
                      <div id="unismarter-slider-img" className="swiper-slide logo-position1"><a href="#"><img id="unismarter-slider-img" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/LTCA_Brand_mas_hor_CMYK-min_akgot2.png" alt="" /></a></div>
                      <div id="unismarter-slider-img" className="swiper-slide logo-position7"><a href="#"><img id="unismarter-slider-img" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/ECC_ECU_Co_Brand_CMYK-min_qiarba.png" alt="" /></a></div>
                      <div id="unismarter-slider-img" className="swiper-slide logo-position3"><a href="#"><img id="unismarter-slider-img" src="https://media.publit.io/file/TheWorldgrad/3Institutions/Austrila/SIBT_WSUSCC_Lockup_CMYK-min_rfjmio.png" alt="" /></a></div>
                      <div id="unismarter-slider-img" className="swiper-slide logo-position8"><a href="#"><img id="unismarter-slider-img" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/BPC_Logo_CMYK_pdxhhx.png" alt="" /></a></div>
                      <div id="unismarter-slider-img" className="swiper-slide logo-position6"><a href="#"><img id="unismarter-slider-img" src="https://media.publit.io/file/TheWorldgrad/UniversityLogosCommon/Final_Murdoch_mjnnf4.jpg" alt="" /></a></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
export default UnismarterPartnerUniversitiesSlider;